import React, { useEffect, useState } from "react";
import "../css/Acquisition.css";
import 'font-awesome/css/font-awesome.min.css';
import '@fontsource/poppins';
import giftIcon from "../images/Acquisition/gift-icon.svg";
import { Carousel, Tooltip, OverlayTrigger } from 'react-bootstrap';
import PageLoader from '../subComponents/PageLoader';
import SafeImage from '../subComponents/SafeImage';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ZoomModal from "./ZoomModal";

const UserGiftSelection = ({ gifts, onGiftSelect, type=false }) => {
  const [selectedGift, setSelectedGift] = useState(null);
  const [showZoomModal, setShowZoomModal] = useState(false);
  const [zoomImages, setZoomImages] = useState([]);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [showTooltip, setShowTooltip] = useState(true);
  
  useEffect(() => {
      setShowTooltip(
      'ontouchstart' in window ||
      (navigator.maxTouchPoints > 0 && window.matchMedia('(hover: none)').matches)
      );
  }, []);

  useEffect(() => {
    if (gifts.length > 0) {
      setSelectedGift(gifts[0]);
      if(!type) {
        onGiftSelect(gifts[0]);
      }
    }
  }, [gifts]);

  const handleGiftChange = (gift) => {
    setSelectedGift(gift);
    if(!type) {
        onGiftSelect(gift);
    }
  };
  
  const handleImageZoom = (images, index = 0) => {
      setZoomImages(images);
      setCarouselIndex(index);
      setShowZoomModal(true);
  };

  const renderTooltip = (props) => (
      <Tooltip id="zoom-tooltip" className="custom-tooltip-image" {...props}>
      Click to zoom in and view details
      </Tooltip>
  );

  const renderImagePreview = (gift) => {
      const imageBlock = (
      <div className="mr-3"
          onClick={(e) => {
          e.stopPropagation();
          handleImageZoom(gift.images, 0);
          }}
          style={{ cursor: 'zoom-in' }}
        >
            {/* <SafeImage src={gift.image} alt={gift.name} className="gift-image" /> */}
            {gift?.images?.length > 1 ? (
                <Carousel
                    indicators={false}
                    controls={false}
                    interval={null}
                    fade={true}
                    // nextIcon={<span aria-hidden="true" className="carousel-control-next-icon" style={{ filter: "invert(1)" }} />}
                    // prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon" style={{ filter: "invert(1)" }} />}
                >
                    {gift?.images.map((imgUrl) => (
                        <Carousel.Item key={`${imgUrl}`}>
                        <SafeImage 
                            src={imgUrl}
                            alt={`${gift?.name}`}
                            className="gift-image"
                        />
                        </Carousel.Item>
                    ))}
                </Carousel>
            ) : (
                <SafeImage 
                    src={gift?.images?.[0]}
                    alt={gift?.name}
                    className="gift-image"
                />
            )}
        </div>
      );

      return !showTooltip ? (
      <OverlayTrigger placement="top" overlay={renderTooltip}>
          {imageBlock}
      </OverlayTrigger>
      ) : imageBlock;
  };

  return (
    <>
      <div className="gift-wrapper gift-details">
          <Accordion defaultExpanded={!type} className="gift-accordion">
          <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="gift-content"
              id="gift-header"
              className="d-flex align-items-center"
          >
                  <div className="gift-head">
                      <img
                          src={giftIcon}
                          alt="Gift Icon"
                          className="gift-icon"
                      />{" "}
                      <span className={`gift-title ${ type ? 'other-plans-gift' : '' }`}>{ type ? "Choose Your Free Gift" : "Unlock Your Complimentary Gift with This Edition" }</span>
                  </div>
          </AccordionSummary>
          <AccordionDetails
            style={{
              padding: "unset",
              display: "unset"
            }}
          >
              <div className="gift-grid">
                  {gifts.map((gift) => (
                  <div
                      key={gift.id}
                      className={` ${!type ? 'gift-card' : 'gift-card-border'} "gift-option d-flex align-items-center mb-2 rounded" ${
                      selectedGift?.id === gift.id && !type ? "bg-info-light gift-card-selected" : "info-light"
                      }`}
                      onClick={() => handleGiftChange(gift)}
                      style={{ cursor: "pointer" }}
                  >
                      <div className="gift-img-container gift-carousel-controls-bottom mr-3" style={{ width: "80px" }}>
                          {renderImagePreview(gift)}
                      </div>
                        
                      <div className="gift-content">
                      <div className="gift-name">{gift.name}</div>
                      <div className="gift-description">{gift.description}</div>
                      </div>
                      <svg className="form__label-check" viewBox="0 0 512 512" title="check-circle">
                          <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
                      </svg> 
                  </div>
                  ))}
              </div>
          </AccordionDetails>
          <Box
          sx={{
            px: 2,
            py: 1,
            fontSize: 12
          }}
        >
          <b>Note:</b> Gift images shown are for illustration purposes only. Actual products may vary in appearance.
        </Box>
          </Accordion>
      
      </div>
      {/* Zoom Modal */}
      <ZoomModal
          show={showZoomModal}
          onClose={() => setShowZoomModal(false)}
          images={zoomImages}
          initialIndex={carouselIndex}
      />
    </>
  );
};
export default UserGiftSelection;
